<!-- 动态列导入-->
<template>
  <div class="container">
    <el-container class="wrapper" ref="wrapper">
      <el-header height="50px" class="page-header">
        <el-form :model="formData" :inline="true" size="mini" style="margin-top: 10px">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="formData.date"
              unlink-panels
              type="daterange"
              style="width: 220px"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item style="float: right; margin-top: -1px">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="reset" class="orange-btn">重置</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main ref="main">
        <div style="margin-bottom: 10px">
          <el-button type="primary" size="small" @click="showExport">导入</el-button>
          <el-button type="primary" size="small" @click="downLoadTemplate">下载模板</el-button>
        </div>
        <el-table
          border
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData.list"
          :height="tableHeight"
          v-if="tableHeight"
          v-loading="loading"
        >
          <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip></el-table-column>
          <el-table-column label="任务描述" prop="taskDesc" show-overflow-tooltip></el-table-column>
          <el-table-column label="任务结果" prop="taskResult" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-link :type="`${scope.row.taskResult == '成功' ? 'primary' : 'warning'}`" :underline="false">{{ scope.row.taskResult }}</el-link>
              <el-link type="info" :underline="false" style="font-size: 12px" @click="log(scope.row)" v-show="scope.row.taskResult == '失败' && scope.row.failType == 2"
                >查看错误日志</el-link
              >
            </template>
          </el-table-column>
          <!-- <el-table-column label="失败原因" prop="failReason" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="导入人" prop="lastUpdatedBy" show-overflow-tooltip></el-table-column>
          <el-table-column label="导入时间" prop="lastUpdateDate" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="100px" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="downloadRes(scope.row.filePath, scope.row.fileName)" :disabled="!scope.row.filePath">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paginationOpt.pageNum"
            :page-sizes="paginationOpt.pageSizes"
            :page-size="paginationOpt.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationOpt.total"
          >
          </el-pagination>
        </div>
      </el-main>
    </el-container>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="handleDialogClose">
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px" size="small">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValid"
                    >上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
    <q-dialog
      :visible="dialogVisible"
      title="错误日志"
      width="50%"
      :innerScroll="true"
      :innerHeight="300"
      @confirm="confirm"
      @cancel="confirm"
      @close="confirm"
    >
      <div style="padding-bottom: 15px; line-height: 22px" v-html="rowData.failReason" v-if="rowData.failType == 2"></div>
      <!-- <el-table border :header-cell-style="{ backgroundColor: '#F4F8FB' }" :data="rowData.failReason" :height="300" v-else v-loading="loading">
        <el-table-column label="列名" prop="fieldName" show-overflow-tooltip></el-table-column>
        <el-table-column label="第几行" prop="rowIdx" show-overflow-tooltip></el-table-column>
        <el-table-column label="错误信息" prop="message" show-overflow-tooltip></el-table-column>
      </el-table> -->
    </q-dialog>
  </div>
</template>
<script>
import axios from "@/utils/axiosInstance";
import { getToken } from "@/utils/auth";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  components: {},
  mixins: [pagePathMixin],
  data() {
    return {
      requesting: false,
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      dialogFormVisible: false,
      dialogVisible: false,
      options: [],
      titleName: "",
      rowData: {},
      requestParam: {},
      tableData: [],
      formData: {},
      formDataImport: {},
      rules: {},
      queryCriteria: [],
      fjLoading: false,
      loading: false,
      tableHeight: 0,
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      templateData: "",
    };
  },
  mounted() {
    this.getTemplate();
    this.tableHeight = this.$refs["wrapper"].$el.offsetHeight - 175;
    this.handleSearch();
  },
  methods: {
    cancel() {
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      this.fileList = [];
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      // .xls,.xlsx,.xls.ttt,.xlsx.ttt
      let pattern = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (["xls", "xlsx", "xls.ttt", "xlsx.ttt"].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error("请上传后缀名为.xls,.xlsx的附件！");
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs["requestParam"].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error("参数校验失败！");
        }
      });
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error("请先上传Excel附件");
        return;
      }
      this.fjLoading = true;
      var formDataImport = new FormData();
      formDataImport.append("file", this.fileList[0]);
      this.$q.dataImport
        .pddGoodsPriceInfo({data: formDataImport})
        .then((res) => {
          this.fjLoading = false;
          const h = this.$createElement;
          if (res.success) {
            this.$message.success("数据导入中，请稍后");
          } else if (res.code == 600) {
            let tableData = JSON.parse(res.message);
            this.$notify.error({
              title: "错误",
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: h(
                "el-table",
                {
                  props: { data: tableData, border: true, height: "250", size: "mini" },
                  style: { with: "100%" },
                },
                [
                  h("el-table-column", { props: { prop: "rowIdx", width: "60", label: "第几行" } }, {}),
                  h(
                    "el-table-column",
                    {
                      props: {
                        prop: "message",
                        width: "350",
                        label: "错误信息",
                        ["show-overflow-tooltip"]: true,
                      },
                    },
                    {}
                  ),
                ]
              ),
            });
          } else {
            this.$message.error(res.message);
          }
          this.cancel();
          this.handleSearch();
          this.$refs.upload.submit();
        })
        .catch((err) => {
          this.fjLoading = false;
        });
    },
    showExport() {
      this.fileList = [];
      this.dialogFormVisible = true;
      let filename = this.$route.query.fileName;
      filename = filename.substring(0, filename.lastIndexOf('.'))
      this.titleName = filename;
    },
    //错误状态显示log
    log(row) {
      let data = { ...row };
      if (data.failType != 2) {
        data.failReason = JSON.parse(data.failReason);
      }
      this.rowData = data;
      this.dialogVisible = true;
    },
    confirm(data) {
      this.dialogVisible = false;
    },
    blobDownload(res, fileName) {
      let objectUrl = window.URL.createObjectURL(res);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      a.remove();
    },
    async downloadRes(filePath, fileName) {
      let url = filePath;
      console.log(url);
      let response = await fetch(url, { mode: "cors" });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = objectUrl;
      a.download = fileName + "" + url.substring(url.lastIndexOf("."));
      a.click();
      a.remove();
    },
    handleSearch() {
      this.paginationOpt.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "reportCode",
          val: "pddGoodsPriceInfoImport",
          op: "=",
        },
        {
          attributeName: "importDate", //日期
          val: this.formData.date && this.formData.date.length ? this.formData.date : [],
          op: "range",
        },
      ];
      this.init();
    },
    reset() {
      this.formData = {};
      this.handleSearch();
    },
    init() {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        reportCode: "pddGoodsPriceInfoImport",
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
      };
      console.log(data);
      axios
        .post(`/ec-pc-api/custom/reports/data/dynamicImportHistory`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    /**
     * 下载模板
     */
    // 获取导入模板
    // 获取导入模板
    async getTemplate() {
      let res = await axios.get(`/qu-platform-excel-api/excel/cfg/getTemplate/${this.$route.query.reportName}`);
      this.templateData = res.data;
    },
    downLoadTemplate() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout((_) => {
        this.downLoad(this.templateData.templatePath, `${this.templateData.fileName}.XLSX`);
        loading.close();
      }, 300);
    },
    downLoad(path, name) {
      let url = path;
      let fileName = name;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 10px;
  width: auto;
  height: calc(100vh - 86px);
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0;
  background: transparent;
  border: 0;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 20px;
  margin-bottom: 10px !important;
  position: relative;
  border-radius: 5px;
}

>>> .el-main {
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
}

>>> .el-tabs__header {
  margin-bottom: 0;
}

>>> .word .el-input__inner {
  width: 300px;
}

>>> .word .el-input.el-input--small.el-input--suffix {
  width: 300px;
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 0 !important;
}

>>> .el-dialog__header {
  background: #2eb58d;
  position: relative;
}

>>> .el-dialog__header .el-dialog__title {
  font-size: 14px;
  color: #fff;
}

>>> .el-dialog__header {
  padding: 10px;
}

>>> .el-dialog__header .el-dialog__headerbtn .el-icon {
  color: #fff;
}

>>> .el-dialog__headerbtn {
  position: absolute;
  top: 50%;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 16px;
  transform: translate(0, -50%);
}

.el-icon-close:before {
  color: #eee;
}

>>> .el-dialog__body {
  padding: 15px;
}

>>> .el-notification {
  width: 500px !important;
}

>>> .el-header >>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 200px !important;
}
</style>
